<template>
    <div class="card shadow-sm mb-3 bg-light">
        <div class="card-header-item p-1" :class="headerColor">
            <div class="row px-2">
                <div class="col-3">
                    <span class="mr-2" style="font-size: 14px">
                        <i :class="icon"></i>
                    </span>
                    {{ event.created_at | moment('dddd Do MMMM') }}
                </div>
                <div class="col-9 pt-1 text-right">
                    <span class="item-footer"
                    >{{ footer }} {{ achievement }}</span
                    >
                </div>
            </div>
        </div>
        <div class="card-body p-3">
            <b-form-group label="Titre de la tâche" class="mt-0">
                <b-input
                    v-model="form.description"
                    :disabled="!event.can_edit"
                />
            </b-form-group>
            <label>Commentaires</label>
            <vue-editor
                id="comments"
                v-model="form.comments"
                class="bg-white"
                :editor-toolbar="customToolbar"
            />
            <div class="row mt-3">
                <div class="col-3">
                    <b-form-group label="Tâche affectée à">
                        <b-form-select
                            v-model="form.assigned_to"
                            :disabled="!event.can_edit"
                            size="sm"
                            :options="options"
                            style="height: 30px"
                        ></b-form-select>
                    </b-form-group>
                </div>
                <div class="col-3">
                    <label>Echéance</label>
                    <b-input-group>
                        <b-form-input
                            id="current-date"
                            v-model="formatted_deadline_date"
                            type="text"
                            placeholder="Date à définir"
                            autocomplete="off"
                            size="sm"
                            disabled
                            class="bg-white"
                            style="height: 30px"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker
                                v-model="form.deadline_date"
                                :disabled="!event.can_edit"
                                button-only
                                right
                                label-no-date-selected="Date à définir"
                                label-prev-year="Année précédente"
                                label-next-year="Année prochaine"
                                label-prev-month="Mois précédent"
                                label-next-month="Mois prochain"
                                label-current-month="Mois actuel"
                                label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                                start-weekday="1"
                                aria-controls="current-date"
                                locale="fr"
                                @context="formatDeadlineDate"
                            >
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-2">
                    <label>Priorité</label>
                    <b-form-select
                        v-model="form.priority"
                        :disabled="!event.can_edit"
                        :options="priorityOptions"
                        size="sm"
                        style="height: 30px"
                    />
                </div>
                <div class="col-1">
                    <b-form-group>
                        <label>Budget (h)</label>
                        <b-input v-model="form.budgeted_duration"
                                 type="numeric"
                                 step="0.1"
                                 size="sm"
                                 class="text-right" />
                    </b-form-group>
                </div>
                <div class="col-3">
                    <b-form-group>
                        <label>
                            Facturation de la tâche
                            <b-link
                                title="Si la tâche est facturable, sélectionner la rubrique de facturation"
                                class="text-primary ml-2"
                            >
                                <i class="far fa-info-circle"></i>
                            </b-link>
                        </label>
                        <b-form-select
                            v-model="form.billing_option_id"
                            :options="billableTimeSheetsOptions"
                            size="sm"
                            style="height: 30px"
                        >
                            <template #first>
                                <b-form-select-option :value="null">
                                    Tâche non facturable
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>

            <div class="mt-2">
                <b-button variant="success" size="sm" @click="updateTask">
                    <i class="far fa-save fa-fw mr-2"/>Enregistrer
                </b-button>
                <b-button variant="success" size="sm" @click="checkTask">
                    <i class="far fa-check fa-fw mr-2"/>Fait
                </b-button>
                <b-button variant="secondary" size="sm" @click="close">
                    <i class="far fa-times fa-fw mr-2"/>
                    Annuler
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'TaskEdit',

    components: {
        VueEditor
    },

    mixins: [DataUpdater],

    props: {
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            form: {
                // assigned_to,
                // budgeted_duration,
                // billing_option_id,
                // priority,
                // description: ''
            },
            editing: false,
            formatted_deadline_date: '',
            priorityOptions: [
                { value: 'H', text: 'Haute' },
                { value: 'N', text: 'Normale' },
                { value: 'Z', text: 'Basse' }
            ],
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }]
            ]
        }
    },

    created() {
        this.$store.commit('browsing/UN_SKIP_INIT')
    },

    mounted() {
        this.editing = this.editingState
        this.form.description = this.event.description
        this.form.comments = this.event.comments
        this.form.priority = this.event.priority
        this.form.budgeted_duration = this.event.budgeted_duration
        this.form.billing_option_id = this.event.billing_option_id
        this.billable = this.event.billable === 1
        this.form.assigned_to = this.event.assigned_to.id
        this.form.deadline_date = this.$moment(this.event.deadline_date).format(
            'YYYY-MM-DD'
        )
    },

    methods: {
        async close() {
            this.$store.commit('browsing/RESET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.index')
            await this.$parent.getItems()
        },

        async checkTask(){
            try {
                await axios.put(
                    `/clientEvents/${this.event.id}/toggle`,
                    this.form
                )
                await this.close()
            } catch (error) {
                console.log(error)
            }
        },

        async updateTask() {
            try {
                this.form.client_id = this.event.client
                    ? this.event.client.id
                    : null
                this.form.billable = this.form.billing_option_id !== null
                await axios.put(
                    `/clientEvents/task/${this.event.id}`,
                    this.form
                )
                await this.close()
            } catch (error) {
                console.log(error)
            }
        },

        formatDeadlineDate(ctx) {
            this.formatted_deadline_date = ctx.selectedFormatted
        }
    },

    computed: {
        ...mapState({
            editingState: (state) => state.browsing.editing,
            accountingFirmUsers: (state) =>
                state.data.options.accountingFirmUsers,
            billableTimeSheetsOptions: (state) =>
                state.data.options.billableTimeSheets
        }),

        options() {
            return this.accountingFirmUsers.filter((item) => item.value !== 0)
        },

        billingSwitchTitle() {
            return this.billable ? 'Tâche facturable' : 'Tâche non facturable'
        },

        isTask() {
            return this.event.assigned_to !== null
        },

        footer() {
            return this.isTask
                ? `Tâche créée par ${this.event.created_by.name}`
                : `Evènement créé par ${this.event.created_by.name}`
        },

        icon() {
            return this.isTask ? 'far fa-tasks' : 'far fa-history'
        },

        headerColor() {
            if (this.isTask) {
                if (this.event.late) {
                    return 'bg-danger'
                }
                if (this.event.soon) {
                    return 'bg-warning'
                }
                return ''
            }
            return ''
        },

        achievement() {
            if (this.isTask && !this.editing) {
                if (this.event.done) {
                    const achievementDate = this.$moment(
                        this.event.achievement_date
                    )
                    return `, réalisée par ${
                        this.event.assigned_to.name
                    } le ${achievementDate.format('Do MMMM YYYY')}`
                }
                const deadlineDate = this.$moment(this.event.deadline_date)
                return `, à réaliser par ${
                    this.event.assigned_to.name
                } avant le ${deadlineDate.format('Do MMMM')}`
            }
            return ''
        }
    }
}
</script>

<style scoped>
.card-header-item {
    background-color: #594f47;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    padding-left: 5px;
}
</style>
